'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var privateKeys = ['clear', 'getItem', 'setItem', 'key', 'removeItem', 'length'];
var MemoryStorage = function () {
    return {
        length: 0,
        clear: function () {
            var _this = this;
            Object.keys(this).map(function (key) {
                if (privateKeys.indexOf(key) === -1) {
                    delete _this[key];
                }
            });
        },
        getItem: function (key) {
            if (privateKeys.indexOf(key) === -1) {
                return this[key] || null;
            }
        },
        key: function (index) {
            return Object.keys(this).filter(function (key) {
                return privateKeys.indexOf(key) === -1;
            })[index] || null;
        },
        removeItem: function (key) {
            if (privateKeys.indexOf(key) === -1) {
                delete this[key];
            }
        },
        setItem: function (key, value) {
            if (privateKeys.indexOf(key) === -1) {
                this[key] = value;
                this.length = Object.keys(this).filter(function (key) { return privateKeys.indexOf(key) === -1; }).length;
            }
        }
    };
};

exports.MemoryStorage = MemoryStorage;
